import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageLayout from "Layouts/PageLayout";
import Button from "Components/Button";
import PrintIcon from "Assets/SVG/PrintIcon";
import Pagination from "../../../Components/Pagination";
import useQueryParams from "../../../Hooks/UseQueryParams";
import PrintingTypeList from "../../../Features/Prints/Components/PrintingTypeList";
import {usePrintingTypes} from "../../../Apis/PrintingTypeApi";

const Index = () => {
    
    const { t } = useTranslation();

    const [ filter, setFilter ] = useQueryParams();

    const { data: printingTypes, isLoading } = usePrintingTypes(filter);
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('printingTypes')} icon={<PrintIcon />} header={(
            <Button prefix={<PrintIcon fill={"#FFF"} />} text={t('createNewPrintingType')} type={"primary"} onClick={() => navigate("new")} />
        )}>
            <>
                <PrintingTypeList printingTypes={printingTypes?.items} isLoading={isLoading} />

                <Pagination paginatedList={printingTypes} onPageChange={newPage => setFilter({page: newPage})} />
            </>
        </PageLayout>
    )
}

export default Index
